// 在 amfe-flexible 之后执行：把 1rem 的基准限制在手机宽度内，
// PC 端打开时页面以 500px 宽的移动端布局居中显示，而不是整体放大。
const MAX_WIDTH = 500;

function capRem() {
  const docEl = document.documentElement;
  const width = Math.min(docEl.clientWidth, MAX_WIDTH);
  docEl.style.fontSize = width / 10 + "px";
}

capRem();
// amfe-flexible 先注册的监听器先执行，这里再覆盖一次即可
window.addEventListener("resize", capRem);
window.addEventListener("pageshow", (e) => {
  if (e.persisted) capRem();
});
